import { z } from 'zod';
import { professionSchema } from './IProfession';

// Schemas (source of truth)
/**
 * Profession schema for API responses.
 * On enrichment success: all fields from IProfession present.
 * On enrichment failure: only minimized fields (_id, tradeId, tradeGroup, projectId, organizationId) guaranteed.
 * dateCreated uses dateField (accepts both Date and ISO string) — no override needed.
 */
export const professionResponseSchema = professionSchema
	.partial()
	.required({ _id: true, tradeId: true, tradeGroup: true, projectId: true, organizationId: true });

// Types (derived from schemas)
export type IProfessionResponse = z.infer<typeof professionResponseSchema>;
